import { render, staticRenderFns } from "./OptionsCarriersResponsive.vue?vue&type=template&id=631a4648&scoped=true"
import script from "./OptionsCarriersResponsive.vue?vue&type=script&lang=js"
export * from "./OptionsCarriersResponsive.vue?vue&type=script&lang=js"
import style0 from "./OptionsCarriersResponsive.vue?vue&type=style&index=0&id=631a4648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a4648",
  null
  
)

export default component.exports